module.exports = __webpack_public_path__ + "static/media/banner-servicios.ce583a23.jpg";